import React, { useRef, useEffect, useMemo, useState, useCallback } from 'react';
import { Column, Lookup } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import IRoulotte from "../../models/IRoulotte";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import { Button } from 'devextreme-react';
import FileUploader, { FileUploaderTypes } from 'devextreme-react/file-uploader';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionPointsEau from '../gestion-points-eau/gestion-points-eau';
import useEnum from '../../hooks/useEnum';
import GestionReservations from '../gestion-reservations/gestion-reservations';
import GestionCouleur from '../gestion-couleurs/gestion-couleurs';
import GestionMarque from '../gestion-marques/gestion-marques';
import useClient from '../../components/selectbox/client';
import GestionEnregistrement from '../gestion-enregistrement/gestion-enregistrement';
import useApi from '../../hooks/useApi';
import IPhotos from '../../models/IPhoto';
import GestionRoulottteRenderPhoto from './gestion-roulottte-render-photos';
import './gestion-roulottes.css'
import Guid from "../../models/Guid";

interface IGestionRoulottes {
  isModeSelection?: boolean,
}

export default function GestionRoulottes({ isModeSelection }: IGestionRoulottes) {
  const formRef = useRef<FormRef>(null);
  const clientFormDataSource = useCustomDataSource<IRoulotte, IRoulotte>({
    path: "roulotte",
    primaryKey: "idRoulotte",
    customReadByIdPath: "roulotte/{key}/gestion",
    customSauvegarderPath: "roulotte/save"
  });
  const { setMainForm, selectedDataRow: selectedRoulotte, mode, setMode, isFieldModifier, setIsFieldModifier, setSelectedDataRow } = clientFormDataSource;
  const { editorOptions: reservationEnteteEditorOption, PopupGestion: PopupGestionReservationEntete } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'reservationEntete', showClear: mode !== Mode.Lecture, width: '60%'
    , onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idReservationEntete", Guid.empty.toString());
    },
  });
  const { editorOptions: pointEauEditorOption, PopupGestion: PopupGestionPointEau } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'pointeau', showClear: mode !== Mode.Lecture, width: '220px'
    , onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPointEau", Guid.empty.toString());
    },
  });
  const { editorOptions: marqueEditorOption, PopupGestion: PopupGestionMarque } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'marque', showClear: mode !== Mode.Lecture, titre: 'Gestion des marques'
    , onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idMarque", Guid.empty.toString());
    },
  });
  const { editorOptions: couleurEditorOption, PopupGestion: PopupGestionCouleur } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'couleur', showClear: mode !== Mode.Lecture
    , onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idCouleur", Guid.empty.toString());
    },
  });
  const { editorOptions: enregistrementEnteteEditorOption, PopupGestion: PopupGestionEnregistrementEnteteEntree } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'enregistrementEntete', showClear: mode !== Mode.Lecture, width: '60%'
    , onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idEnregistrementEnteteEntree", Guid.empty.toString());
    },
    titre: "Gestionnaire des enregistrements"
  });
  const { editorOptions: enregistrementEnteteSortieEditorOption, PopupGestion: PopupGestionEnregistrementEnteteSortie } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'enregistrementEntete', showClear: mode !== Mode.Lecture, width: '250px'
    , onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idEnregistrementEnteteSortie", Guid.empty.toString());
    },
    titre: "Gestionnaire des enregistrements"
  });
  const { editorOptions: typeCampingEditorOption } = useEnum(undefined, "gestionRoulottesTypeCamping", '60%');
  const { editorOptions: typeRoulottesEditorOption } = useEnum(undefined, "gestionRoulottesTypeRoulotte", '60%');
  const { clientEditorOptions, PopupGestionClient } = useClient(true);
  const [imageSource, setImageSource] = useState<string>('');
  const [photos, setPhoto] = useState<IPhotos[]>([]);
  const [selectedPhoto, setSelectedPhoto] = useState<Guid>();
  const { getData: getPhoto } = useApi('roulotte');
  const { getData: getPhotos } = useApi('EnregistrementEntete');
  const fileUploaderRef = useRef<any>(null);
  const gestionEnregistrementPopup = useMemo(
    () => <GestionEnregistrement isModeSelection={true} />,
    []
  );
  useEffect(() => {
    if (selectedRoulotte.idRoulotte !== undefined) {
      try {
        getPhoto({ customPath: `roulotte/${selectedRoulotte.idRoulotte}/getPhoto` })
          .then((result) => {
            const photos = result as IPhotos[]
            setPhoto(photos)
          })
          .catch((errer) => {
          })

        getPhotos({ customPath: `EnregistrementEntete/AllEnregistrements` })
          .then((result) => {
          })
          .catch((errer) => {
          })
      } catch (error) {

      }
    }
  }, [selectedRoulotte])

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IRoulotte) => {
      return { ...prev, [e]: item.id }
    })
  }
  const addPhoto = () => {
    setPhoto([]);
  };

  const deletePhoto = (idPhoto: Guid) => {
    setPhoto(photos.filter(photo => (!photo.idPhoto.equals(idPhoto))));
  };
  const onUploaded = useCallback((e: FileUploaderTypes.BeforeSendEvent) => {
    const { file } = e;
    const fileReader = new FileReader();
    fileReader.onload = () => {
      console.log('ddd', fileReader.result)
      setImageSource(fileReader.result as string);
    };
    fileReader.readAsDataURL(file);
  }, []);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileReader = new FileReader();

      fileReader.onload = () => {
        setImageSource(fileReader.result as string);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const noVignetteOptions = useMemo(() => {
    return { maxLength: 50, width: '60%' }
  }, []);
  const cheminOptions = useMemo(() => {
    return { maxLength: 100 };
  }, []);
  const coordonneesOptions = useMemo(() => {
    return { maxLength: 100 };
  }, []);
  const horsZecOptions = useMemo(() => {
    return {
      text: "Hors-zec",
    };
  }, []);
  const conformiteEquipementOptions = useMemo(() => {
    return { text: "Comformité de l'équipement" };
  }, []);
  const noPlaqueOptions = useMemo(() => {
    return { maxLength: 50 };
  }, []);
  const dimensionOptions = useMemo(() => {
    return { maxLength: 50 };
  }, []);
  const commentairesEntreeOptions = useMemo(() => {
    return { height: 214, maxLength: 4000 };
  }, []);
  const remiseEtatSiteOptions = useMemo(() => {
    return { text: "Remise en état du site", alignment: 'left' };
  }, []);
  const commentairesSortieOptions = useMemo(() => {
    return { height: 142, maxLength: 4000 };
  }, []);
  const actifOptions = useMemo(() => {
    return { text: "Active" };
  }, []);
  const editorOptions = useMemo(() => {
    return { width: '60%', displayFormat: 'dd-MM-yyyy' };
  }, []);
  const anneeEditorOptions = useMemo(() => {
    return {
      width: 70,
      // stylingMode: 'outlined',
      inputAttr: { style: 'text-align: right; padding-inline-end: 0px;' }
    };
  }, []);
  const dateDeSortieEditorOptions = useMemo(() => {
    return {
      width: '250', displayFormat: 'dd-MM-yyyy',
    };
  }, []);

  const onFileUploaded = (e: any, type: string) => {
    const file = e.value[0];
    if (file && (type === 'ROE' || type === 'ROS') &&
      selectedRoulotte?.idRoulotte) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const result = event.target?.result as string;
        const base64 = result.split(',')[1];

        // const newPhoto = {
        //   idPhoto: new Guid(),
        //   typeAuxiliaire: type,
        //   photoBytes: base64,
        //   "isDeleted": false,
        // }

        // TODO server return Photos null

        const newPhoto: IPhotos = {
          idPhoto: new Guid(),
          idAuxiliaire: selectedRoulotte.idRoulotte!,
          typeAuxiliaire: type,
          photoBytes: base64,
          dateCreation: new Date(),
          dateModification: new Date(),
          dateSuppression: null,
          idUsagerCreation: new Guid(),
          idUsagerModification: new Guid(),
          idUsagerSuppression: null,
          isDeleted: false
        };

        setSelectedDataRow((prevState) => ({
          ...prevState,
          photos: [...(prevState.photos || []), newPhoto]
        }));
        setIsFieldModifier(true);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <FormListBase data={clientFormDataSource}>
      <FormListBaseGrid dataSource={clientFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture);
          }
        }}>
        <Column key={"grid-col-id-client"} dataField={"idClient"} caption="Client" allowHiding={false}>
          <Lookup {...clientEditorOptions} />
        </Column>
        <Column key={"grid-col-date-entree"} dataField={"dateEntree"} caption="Date d'entrée" allowHiding={false} format="yyyy-dd-MM" />
        <Column key={"grid-col-date-sortie-prevue"} dataField={"dateSortiePrevue"} caption="Date de sortie prévue" allowHiding={false} format="yyyy-dd-MM" />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`Détail`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ?
        <FormListBaseTab>
          <PopupGestionClient isModeSelection={mode !== Mode.Lecture} onSelectionchanged={(i) => onSelectionchanged(i, 'idClient')} />
          <PopupGestionEnregistrementEnteteEntree
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idEnregistrementEnteteEntree", data.idEnregistrementEntete);
            }}
          >
            {gestionEnregistrementPopup}
          </PopupGestionEnregistrementEnteteEntree>

          <PopupGestionReservationEntete
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idReservationEntete", data.idReservationEntete);
            }}
          >
            <GestionReservations isModeSelection={true} />
          </PopupGestionReservationEntete>

          <PopupGestionPointEau
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idPointEau", data.idPointEau);
            }}
          >
            <GestionPointsEau isModeSelection={true} />
          </PopupGestionPointEau>
          <PopupGestionEnregistrementEnteteSortie
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idEnregistrementEnteteSortie", data.idEnregistrementEntete);
            }}
          >
            <GestionEnregistrement isModeSelection={true} />
          </PopupGestionEnregistrementEnteteSortie>
          <PopupGestionMarque
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idMarque", data.idMarque);
            }}
          >
            <GestionMarque isModeSelection={true} />
          </PopupGestionMarque>
          <PopupGestionCouleur
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idCouleur", data.idCouleur);
            }}
          >
            <GestionCouleur isModeSelection={true} />
          </PopupGestionCouleur>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedRoulotte || {} as IRoulotte} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={(e) => setIsFieldModifier(true)}>
              <GroupItem colCount={5}>
                <GroupItem colSpan={2}>
                  <SimpleItem key={"frm-id-client"} dataField={"idClient"} editorOptions={clientEditorOptions} editorType={'dxSelectBox'}>
                    <Label text={"Client"} showColon={false} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-entree"} dataField={"dateEntree"} editorType={"dxDateBox"} editorOptions={editorOptions}>
                    <Label text={"Date d'entrée"} showColon={false} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-sortie-prevue"} dataField={"dateSortiePrevue"} editorType={"dxDateBox"} editorOptions={editorOptions}>
                    <Label text={"Date prévue"} showColon={false} />
                  </SimpleItem>
                  <SimpleItem key={"frm-no-vignette"} dataField={"noVignette"}
                    editorOptions={noVignetteOptions}>
                    <Label text={"Numéro de vignette"} showColon={false} />
                  </SimpleItem>
                  <SimpleItem key={"frm-id-enregistrement-entete-entree"} dataField={"idEnregistrementEnteteEntree"}
                    editorOptions={enregistrementEnteteEditorOption}
                    editorType={"dxSelectBox"}>
                    <Label text={"Enregistrement"} showColon={false} />
                  </SimpleItem>
                  <SimpleItem key={"frm-id-reservation-entete"} dataField={"idReservationEntete"} editorOptions={reservationEnteteEditorOption} editorType={'dxSelectBox'}>
                    <Label text={"Réservation"} showColon={false} />
                  </SimpleItem>
                  <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                    editorOptions={actifOptions}>
                    <Label text={"Saison"} showColon={false} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Coordonées de l'équipement"}
                  colSpan={3}>
                  <GroupItem>
                    <SimpleItem key={"frm-closest-waterpoint"} dataField={"idPointEau"} editorType={'dxSelectBox'} editorOptions={pointEauEditorOption}
                    >
                      <Label text={"Point d'eau le plus près"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-chemin"} dataField={"chemin"}
                      editorOptions={cheminOptions} />
                    <SimpleItem key={"frm-coordonnees"} dataField={"coordonnees"}
                      editorOptions={coordonneesOptions}
                    >
                      <Label text={"Coordonnées"} />
                    </SimpleItem>
                    <GroupItem colCount={3}
                      alignItemLabels={false}
                    >
                      <SimpleItem key={"frm-hors-zec"}
                        dataField={"horsZec"} editorType={"dxCheckBox"}
                        editorOptions={horsZecOptions}
                        colSpan={1}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                      <SimpleItem key={"frm-conformite-equipement"}
                        dataField={"conformiteEquipement"}
                        editorType={"dxCheckBox"}
                        editorOptions={conformiteEquipementOptions}
                        colSpan={2}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                    </GroupItem>
                  </GroupItem>
                </GroupItem>
              </GroupItem>
              <GroupItem caption={"Équipement"}>
                <GroupItem colCount={5}>
                  <GroupItem colSpan={2}>
                    <SimpleItem key={"frm-type-camping"} dataField={"typeCamping"} editorType={"dxSelectBox"} editorOptions={typeCampingEditorOption}
                    >
                      <Label text={"Type de camping"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-type-roulotte"} dataField={"typeRoulotte"} editorType={"dxSelectBox"} editorOptions={typeRoulottesEditorOption}
                    >
                      <Label text={"Type de roulotte"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-no-plaque"} dataField={"noPlaque"}
                      editorOptions={noPlaqueOptions}
                    >
                      <Label text={"Numéro de plaque"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-id-marque"} dataField={"idMarque"} editorOptions={marqueEditorOption} editorType={'dxSelectBox'}
                    >
                      <Label text={"Marque"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-id-couleur"} dataField={"idCouleur"} editorOptions={couleurEditorOption} editorType={'dxSelectBox'}
                    >
                      <Label text={"Couleur"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-dimension"} dataField={"dimension"}
                      editorOptions={dimensionOptions}
                    >
                      <Label text={"Dimensions"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-annee"} dataField={"annee"} editorOptions={anneeEditorOptions}
                    >
                      <Label text={"Année"} />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem colSpan={3}>
                    <SimpleItem key={"frm-commentaires-entree"} dataField={"commentairesEntree"}
                      editorType={"dxTextArea"}
                      editorOptions={commentairesEntreeOptions}
                    >
                      <Label text={"Commentaires"} location={"top"} />
                    </SimpleItem>
                  </GroupItem>
                </GroupItem>
              </GroupItem>
              <GroupItem caption={"Sortie de l'équipement"}>
                <GroupItem colCount={2}>
                  <SimpleItem key={"frm-date-sortie-reelle"} dataField={"dateSortieReelle"} editorType={"dxDateBox"}
                    editorOptions={dateDeSortieEditorOptions}
                  >
                    <Label text={"Date de sortie validée"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-remise-etat-site"} dataField={"remiseEtatSite"} editorType={"dxCheckBox"}
                    editorOptions={remiseEtatSiteOptions}
                  >
                    <Label visible={false} />
                  </SimpleItem>
                </GroupItem>
                <SimpleItem key={"frm-enregistrement-entete-sortie"} dataField={"idEnregistrementEnteteSortie"}
                  editorOptions={enregistrementEnteteSortieEditorOption}
                  editorType={'dxSelectBox'}
                >
                  <Label text={"Enregistrement"} />
                </SimpleItem>
                <SimpleItem key={"frm-commentaires-sortie"} dataField={"commentairesSortie"}
                  editorType={"dxTextArea"}
                  editorOptions={commentairesSortieOptions}
                >
                  <Label text={"Commentaires"} location={"top"} />
                </SimpleItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Photos">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedRoulotte || {} as IRoulotte} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem caption={"Photos d'entrée"}>
                <div style={{ display: 'flex' }}>
                  <div>
                    <FileUploader
                      id={"photo-commandite"}
                      width={'112px'}
                      disabled={mode === Mode.Lecture}
                      ref={fileUploaderRef}
                      accept="image/*"
                      uploadMode="useForm"
                      onValueChanged={(e) => onFileUploaded(e, 'ROE')}
                      selectButtonText="Ajouter"
                      labelText=""
                      activeStateEnabled={false}
                      showFileList={false}
                    />
                  </div>
                  <div>
                    <Button
                      disabled={mode === Mode.Lecture}
                      text="Supprimer"
                      // onClick={deleteImage}
                      stylingMode="contained"
                    />
                  </div>
                </div>
                <SimpleItem key={"frm-bouttons-photos-entree"}>
                  <span>
                    <Button
                      text={"Supprimer"}
                      onClick={() => deletePhoto(selectedPhoto != undefined ? selectedPhoto : Guid.empty)} />
                  </span>
                </SimpleItem>
              </GroupItem>
              <GroupItem>
                <GestionRoulottteRenderPhoto
                  type='ROE'
                  listePhoto={selectedRoulotte.photos || []}
                  idPhotoSelected={selectedPhoto != undefined ? selectedPhoto : Guid.empty}
                  setSelectedPhoto={(idPhoto) => setSelectedPhoto(idPhoto)}
                  imageWidth={150}
                  imageHeight={110}
                />
              </GroupItem>
              <GroupItem caption={"Photos de sortie"}>
                <div style={{ display: 'flex' }}>
                  <div>
                    <FileUploader
                      id={"photo-commandite"}
                      width={'112px'}
                      disabled={mode === Mode.Lecture}
                      ref={fileUploaderRef}
                      accept="image/*"
                      uploadMode="useForm"
                      onValueChanged={(e) => onFileUploaded(e, 'ROS')}
                      selectButtonText="Ajouter"
                      labelText=""
                      activeStateEnabled={false}
                      showFileList={false}
                    />
                  </div>
                  <div>
                    <Button
                      disabled={mode === Mode.Lecture}
                      text="Supprimer"
                      // onClick={deleteImage}
                      stylingMode="contained"
                    />
                  </div>
                </div>
                <SimpleItem key={"frm-bouttons-photos-entree"}>
                  <span>
                    <Button
                      text={"Supprimer"}
                      onClick={() => deletePhoto(selectedPhoto != undefined ? selectedPhoto : Guid.empty)} />
                  </span>
                </SimpleItem>
              </GroupItem>
              <GroupItem>
                <GestionRoulottteRenderPhoto
                  type='ROS'
                  listePhoto={selectedRoulotte.photos || []}
                  idPhotoSelected={selectedPhoto != undefined ? selectedPhoto : Guid.empty}
                  setSelectedPhoto={(idPhoto) => setSelectedPhoto(idPhoto)}
                  imageWidth={150}
                  imageHeight={110}
                />
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedRoulotte || {} as IRoulotte} /></TabItem>
        </FormListBaseTab> : null}
    </FormListBase>
  );
}
